import React, { createContext, useContext, ReactNode, useMemo } from "react";

interface TrackingContextType {
  trackEvent: (
    name: string,
    context: {
      relatedFeature: number;
      isMetricsTracking?: boolean;
      metadata?: any;
    },
  ) => void;
}

const TrackingContext = createContext<TrackingContextType | undefined>(
  undefined,
);

export const TrackingProvider: React.FC<{
  children: ReactNode;
  trackEventImplementation: TrackingContextType["trackEvent"];
}> = ({ children, trackEventImplementation }) => {
  const value = useMemo(
    () => ({ trackEvent: trackEventImplementation }),
    [trackEventImplementation],
  );

  return (
    <TrackingContext.Provider value={value}>
      {children}
    </TrackingContext.Provider>
  );
};

export const useTracking = (): TrackingContextType => {
  const context = useContext(TrackingContext);
  if (!context) {
    throw new Error("useTracking must be used within a TrackingProvider");
  }
  return context;
};
